













import VueOptions from '@utils/VueOptions'
import ChartUtility from '@utils/ChartUtility'
import BoxChart from '@ui/Dashboard/Charts/BoxChart'

settings =
  name: 'RecapsPostsGaugeChart'

  vue:
    props: ['title', 'data', 'summary']

    components: {
      BoxChart,
    }

    data: ->
      chart: null

    computed:
      reach: ->
        @data?.reach || 0

      total: ->
        @data?.total || 0

      summaryTotal: ->
        @summary?.total || 0

    methods:
      cleanUp: ->
        @chart?.destroy()

      draw: ->
        @chart = new Chart(@$refs.chart, {
          plugins: [ChartDataLabels],
          type: 'doughnut'
          data: {
            labels: [@title]
            datasets: [
              {
                label: 'Posts'
                data: [@data.total, @summaryTotal - @data.total]
                backgroundColor: [ChartUtility.COLORS.blue, ChartUtility.COLORS.grey]
              }
            ],
          }
          options: {
            aspectRatio: 1.8
            layout: {
              padding: {
                top: 12
                bottom: 12
              }
            }
            datasets: {
              doughnut: {
                borderRadius: 100
                borderWidth: 6
                circumference: 180
                rotation: 270
                cutout: '70%'
              }
            }
            hover: {
              mode: null
            }
            plugins: {
              legend: {
                display: false
              }
              tooltip: {
                enabled: false
              }
              datalabels: {
                formatter: (value, context) =>
                  relative = if @summaryTotal > 0 then (value / @summaryTotal) * 100 else 0
                  if context.dataIndex is 0
                    relative.toFixed(1) + "%"
                  else
                    ''
                backgroundColor: (context) =>
                  if context.dataIndex is 0
                    context.dataset.backgroundColor[context.dataIndex]
                  else
                    'transparent'
                color: (context) =>
                  if context.dataIndex is 0
                    ChartUtility.COLORS.white
                  else
                    'transparent'
                padding: 4
                borderRadius: 25
                borderWidth: 1
                borderColor: [ChartUtility.COLORS.white, 'transparent']
                font: {
                  weight: 'bold'
                }
              }
            }
          }
        })

export default VueOptions.vue settings
